// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swoosh-effect {
  position: relative;
  display: inline-block;
}

.swoosh-effect::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0.25em;
  background: #1e3a8a; /* Blue color for the swoosh */
  border-radius: 50%;
  transform: scaleX(1.5) rotate(-5deg);
  z-index: -1;
}`, "",{"version":3,"sources":["webpack://./src/styles/MarketingLanding.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,cAAc;EACd,mBAAmB,EAAE,8BAA8B;EACnD,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;AACb","sourcesContent":[".swoosh-effect {\n  position: relative;\n  display: inline-block;\n}\n\n.swoosh-effect::before {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 0.25em;\n  background: #1e3a8a; /* Blue color for the swoosh */\n  border-radius: 50%;\n  transform: scaleX(1.5) rotate(-5deg);\n  z-index: -1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
